var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left"},[_vm._v(" Mon tableau de bord ")])}
var staticRenderFns = []

export { render, staticRenderFns }